import { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { ArrowLeft, Wand2 } from "lucide-react";
import BlueprintCard from "../components/BlueprintCard";

export default function GalleryDetail() {
  const { id } = useParams();
  const nav = useNavigate();
  const [bp, setBp] = useState(null);

  useEffect(() => {
    api.get(`/gallery/${id}`).then(({ data }) => setBp(data));
  }, [id]);

  const remix = () => {
    nav(`/studio?prompt=${encodeURIComponent(bp.prompt)}`);
  };

  if (!bp) return <div className="container-narrow py-20 text-center text-ink2">Loading…</div>;

  return (
    <div className="container-narrow py-12 md:py-16" data-testid="gallery-detail">
      <Link to="/gallery" className="inline-flex items-center gap-1.5 text-ink2 hover:text-ink mb-6">
        <ArrowLeft className="w-4 h-4" /> Back to atlas
      </Link>

      <div className="card-soft p-6 mb-6 flex flex-wrap items-center justify-between gap-4">
        <div>
          <div className="label-eyebrow mb-1">From the prompt</div>
          <p className="font-heading text-lg italic text-ink">"{bp.prompt}"</p>
          <div className="text-sm text-ink2 mt-1">by {bp.author_name || "Anonymous"}</div>
        </div>
        <button onClick={remix} className="btn-primary" data-testid="gallery-remix-button">
          <Wand2 className="w-4 h-4" /> Remix in Studio
        </button>
      </div>

      <BlueprintCard bp={bp} />
    </div>
  );
}
